import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints, colors, stickyHeader } from '@style-guide/config';
import ClearFix from '@style-guide/mixins/ClearFix';
import Alert from '@components/Alert';
import Login from './components/Login';
import ShoppingCart from './components/ShoppingCart';
import NavMenu from './components/NavMenu';

const Logo = styled.a`
  display: flex;
  float: left;

  img {
    height: ${stickyHeader.stickyHeaderHeight};
  }
`;

Logo.displayName = 'Logo';

const MobileNavContainer = styled.section`
  ${ClearFix()}

  background-color: ${colors.darkBlue};
  border-bottom: 2px solid ${colors.white};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;

  @media (min-width: ${breakpoints.l}) {
    display: none;
  }

  > ul {
    float: right;
  }
`;

MobileNavContainer.displayName = 'MobileNavContainer';

const MobileNav = ({
  alertTitle = '',
  alertMessage = '',
  checkoutLink,
  headerData,
  headerLogo,
  primaryNavItems = [],
  isAuthenticated = false,
  loginLink,
  logoutLink,
  shoppingCartLink,
  userName = '',
}) => (
  <MobileNavContainer>
    {(alertTitle || alertMessage) && (
      <Alert
        title={alertTitle}
        message={alertMessage}
      />
    )}
    <Logo
      href="/?nr"
      id="mobileHeaderLogo"
    >
      <img src={headerLogo} alt="OSBA Logo" />
    </Logo>
    <ul>
      <Login
        isAuthenticated={isAuthenticated}
        loginLink={loginLink}
        logoutLink={logoutLink}
      />
      {window.location.pathname !== checkoutLink && (
        <ShoppingCart
          shoppingCartLink={shoppingCartLink}
          checkoutLink={checkoutLink}
        />
      )}
      <NavMenu
        primaryNavigationItems={primaryNavItems}
        functionalLinks={headerData.functionalLinks}
        legalLinks={headerData.legalLinks}
        isAuthenticated={isAuthenticated}
        shoppingCartLink={shoppingCartLink}
        userName={userName}
        flyoutData={headerData.flyout}
      />
    </ul>
  </MobileNavContainer>
);

MobileNav.propTypes = {
  alertTitle: PropTypes.string,
  alertMessage: PropTypes.string,
  checkoutLink: PropTypes.string.isRequired,
  headerData: PropTypes.shape({
    flyout: PropTypes.instanceOf(Object),
    functionalLinks: PropTypes.instanceOf(Array),
    legalLinks: PropTypes.instanceOf(Array),
    primaryNavigationItems: PropTypes.instanceOf(Array),
    utilityNavigationItems: PropTypes.instanceOf(Array),
  }).isRequired,
  headerLogo: PropTypes.string.isRequired,
  primaryNavItems: PropTypes.arrayOf(Object),
  isAuthenticated: PropTypes.bool,
  loginLink: PropTypes.string.isRequired,
  logoutLink: PropTypes.string.isRequired,
  shoppingCartLink: PropTypes.string.isRequired,
  userName: PropTypes.string,
};

MobileNav.displayName = 'MobileNav';

export default MobileNav;
